var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player",class:_vm.playClass,attrs:{"id":"nativePlayer"}},[_c('video',{attrs:{"id":'stream-player-' + _vm.sid,"playsinline":""},on:{"play":_vm.onplay,"loadedmetadata":_vm.loadPlayer}},[_c('source',{attrs:{"id":'stream-source-' + _vm.sid,"src":_vm.source}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }